import {Injectable} from '@angular/core';

import {patterns} from '../../data/patterns/patterns.manifest.json';
import SewingPatternInterface from '../models/sewing-pattern.interface';
import {FabricRepository} from './fabric.repository';
import PatternAreaInterface from '../models/pattern-area.interface';
import MaterialInterface from '../models/material.interface';

import marked from 'marked';

@Injectable({
    providedIn: 'root'
})
export class PatternRepository {

    private allPatterns: SewingPatternInterface[] = null;

    constructor(private materialRepository: FabricRepository) {
    }

    public all(): SewingPatternInterface[] {
        if (!this.allPatterns) {
            const result = patterns
                .sort((first: any, second: any) => {
                    return first.position - second.position;
                })
                .map(pattern => {
                const areas = pattern.areas.map(area => {
                    const materials = area.materials
                        ? area.materials.map(id => this.materialRepository.materialById(id)) as MaterialInterface[]
                        : this.materialRepository.materials().filter(fabric => fabric.id !== 'buendchen');

                    return {
                        id: `${area.id}`,
                        name: area.name,
                        color: area.color,
                        materials
                    } as PatternAreaInterface;
                });

                return {
                    id: `${pattern.id}`,
                    name: pattern.name,
                    subline: pattern.subline,
                    path: `/assets/configurator/sewing-patterns/${pattern.filename}`,
                    shadowPath: `/assets/configurator/sewing-patterns/${pattern.shadowFilename}`,
                    previewPath: `/assets/configurator/sewing-patterns/${pattern.previewFilename}`,
                    tablePath: `/assets/configurator/sewing-patterns/${pattern.tableFilename}`,
                    fabricChoice: marked(pattern.fabricChoice),
                    areas,
                    instructions: pattern.instructions,
                    width: pattern.width,
                    height: pattern.height
                } as SewingPatternInterface;
            });

            this.allPatterns = result;
        }

        return this.allPatterns;
    }

    public getByIdOrFirst(id): SewingPatternInterface {
        const parsedPatterns = this.all();
        const foundPattern = parsedPatterns.find(pattern => pattern.id === id);
        if (!foundPattern) {
            return parsedPatterns[0];
        }
        return foundPattern;
    }

    public async loadSVGFromPattern(pattern: SewingPatternInterface) {
        const response = await fetch(pattern.path);
        return response.text();
    }

    public async loadShadowSVGFromPattern(pattern: SewingPatternInterface) {
        const response = await fetch(pattern.shadowPath);
        if (response.ok) {
            const svg = await response.text();
            return svg.split('cls').join('shadow-cls');
        }

        return false;
    }
}
